import * as React from 'react'
import { Form, Field, InjectedFormProps, FieldArray, change } from 'redux-form'
import { dispatchToProps, formName } from './ThreadCreateForm.container'
import { vRequired, vStandardNumber } from 'components/Input/Input.validations'
import Autosuggest from 'features/Autosuggest'
import Button from 'components/Button'
import cn from 'classnames'
import * as sMarg from 'styles/modules/margins.scss'
import * as sLay from 'styles/modules/layout.scss'
import * as sText from 'components/Text/Text.scss'
import { Textarea } from 'components/Input/Textarea'
import SelectPretty from 'components/Input/SelectPretty'
import { compact } from 'lodash'
import FieldArrayRows from 'components/Input/FieldArrayRows'
import LoadingOverlay from 'components/Loading/LoadingOverlay'
import { MessagePrice } from '../MessagePrice'
import { THREADS_LIMIT } from '../../../pages/MessageThread/MessageThread'
import {
  useMessageSendMultipleMutation,
  useListMessageThreadsLazyQuery,
  useListSmsServicesQuery,
} from 'src/generated/graphql'

const ArrayValueField = props => {
  return (
    <Field
      component={Autosuggest}
      autosuggestType="contact"
      onSuggestionSelected={(event, item) => {
        const phoneNumber = item.suggestion.value.replace(/^\+61/, '0')
        props.dispatch(change(formName, props.name, phoneNumber))
      }}
      label="Recipient number"
      type="number"
      validate={[vRequired, vStandardNumber]}
      fullWidth={true}
      {...props}
    />
  )
}

export interface IThreadCreateFormComponentProps extends InjectedFormProps<any> {
  formData: any
  push: typeof dispatchToProps['push']
  showNumbersFormModal: typeof dispatchToProps['showNumbersFormModal']
  onConfirm: () => undefined
  dispatch: any
}

export const ThreadCreateFormComponent = (props: IThreadCreateFormComponentProps) => {
  const { formData, handleSubmit, onConfirm, submitting, showNumbersFormModal } = props

  const [listMessageThreadsQuery] = useListMessageThreadsLazyQuery()

  const [messageSendMultipleMutation] = useMessageSendMultipleMutation({
    onCompleted: () => {
      listMessageThreadsQuery({
        variables: { limit: THREADS_LIMIT, page: 1 },
      })
      onConfirm()
    },
  })

  const listSmsServices = useListSmsServicesQuery()
  const options = listSmsServices?.data?.numbers
    ? listSmsServices?.data.numbers.map(service => ({
        name: compact([service.number, service.customerReference]).join(' - '),
        value: service.id,
      }))
    : []
  const otherOptions = [
    {
      name: 'Create new mobile number...',
      value: 'mobile',
      onClick: () => showNumbersFormModal({ numberType: 'mobile' }),
    },
  ]

  return (
    <Form onSubmit={handleSubmit(data => messageSendMultipleMutation({ variables: data }))}>
      <div className={cn(sText.descrip2, sText.center, sMarg.mb30)}>Send SMS Message</div>
      <div className={cn(sText.descrip3, sText.center, sMarg.mb30)}>
        Select 1 or more recipients and send them a once off SMS message.
      </div>
      <div style={{ position: 'relative' }}>
        <Field
          name="serviceId"
          label="From"
          component={SelectPretty}
          options={[...options, ...otherOptions]}
          validate={[vRequired]}
        />
        {listSmsServices.loading && <LoadingOverlay />}
      </div>
      <FieldArray
        name="to"
        dispatch={props.dispatch}
        FieldComponent={ArrayValueField}
        component={FieldArrayRows}
        validate={[vRequired]}
        addText="Add another"
      />
      <Field
        name="body"
        label="Message"
        component={Textarea}
        display="standard"
        validate={[vRequired]}
      />
      <div className={cn(sLay['layout-column'], sLay['layout-align-center-center'], sMarg.mt30)}>
        <div>
          <MessagePrice
            recipients={formData.to ? formData.to.length : 0}
            body={formData.body || ''}
          />
          <Button color="tertiary" loading={submitting} type="submit">
            Send Message
          </Button>
        </div>
      </div>
    </Form>
  )
}



// WEBPACK FOOTER //
// src/features/Messages/ThreadCreateForm/ThreadCreateForm.tsx